/**
 * Islands of Loom — Cart Rewards
 * assets/iol-cart-rewards.js
 *
 * Tier 1 (₹1,999) → free shipping
 * Tier 2 (₹9,999) → "Complimentary Shirt" (₹0 variant) added as a normal line item
 *
 * Approach: add/remove the gift with the same endpoints the theme uses, then
 * hand off to the theme's own re-render. No custom DOM patching.
 */

(function () {
  'use strict';

  var TIER1           = 199900;
  var TIER2           = 999900;
  var GIFT_VARIANT_ID = '46766439006405';

  var giftIndex = -1;    /* 0-based position of the gift in cart.items */
  var mutating  = false; /* true only while our own add/remove is in flight */
  var pending   = null;  /* debounce handle */

  /* ─────────────────────────────────────────
     Sync is debounced and idempotent, so extra
     triggers are harmless — no guard flags needed.
  ───────────────────────────────────────── */
  function sync() {
    clearTimeout(pending);
    pending = setTimeout(run, 150);
  }

  function run() {
    if (mutating) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = subtotalExGift(cart);
        paintBar(total);

        var gift = null;
        giftIndex = -1;
        cart.items.forEach(function (item, i) {
          if (String(item.variant_id) === GIFT_VARIANT_ID) { gift = item; giftIndex = i; }
        });

        lockGiftLine();

        if (total >= TIER2 && !gift)              addGift();
        else if (total >= TIER2 && gift.quantity > 1) setQty(giftIndex + 1, 1);
        else if (total < TIER2 && gift)           setQty(giftIndex + 1, 0);
      })
      .catch(function (e) { console.warn('[IoL]', e); });
  }

  function subtotalExGift(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (String(item.variant_id) !== GIFT_VARIANT_ID) total += item.final_line_price;
    });
    return total;
  }

  /* ─────────────────────────────────────────
     Mutations — flat payload, same as any
     add-to-cart the theme performs.
  ───────────────────────────────────────── */
  function addGift() {
    mutating = true;
    post('/cart/add.js', {
      id:         GIFT_VARIANT_ID,
      quantity:   1,
      properties: { '_iol_free_gift': 'true' }
    });
  }

  function setQty(line, qty) {
    mutating = true;
    post('/cart/change.js', { line: line, quantity: qty });
  }

  function post(url, body) {
    fetch(url, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'rejected');
        }
        mutating = false;
        repaint();
      })
      .catch(function (e) {
        mutating = false;
        console.warn('[IoL] ' + url + ' failed —', e.message);
      });
  }

  /* Hand the re-render to the theme, exactly as it does after its own
     quantity changes. On the cart page there is no drawer helper, so reload
     the section the same way component-cart.js does. */
  function repaint() {
    if (typeof SHTHelper !== 'undefined' &&
        typeof SHTHelper.forceUpdateCartStatus === 'function') {
      SHTHelper.forceUpdateCartStatus();
    }
    if (window.location.pathname === '/cart') {
      fetch('/cart?sections=main-cart')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['main-cart'];
          if (!html) return;
          var doc = (new DOMParser()).parseFromString(html, 'text/html');
          ['.js-cart-items', '.js-cart-total', '.js-cart-level-discount-applications']
            .forEach(function (sel) {
              var fresh = doc.querySelector(sel);
              var cur   = document.querySelector('#mainCart ' + sel);
              if (fresh && cur) cur.innerHTML = fresh.innerHTML;
            });
        })
        .catch(function () {})
        .then(sync);
    } else {
      sync();
    }
  }

  /* ─────────────────────────────────────────
     Progress bar
  ───────────────────────────────────────── */
  function paintBar(total) {
    var pct  = total >= TIER2 ? 100 : Math.round((total / TIER2) * 100);
    var text = total < TIER1
      ? 'Add <strong>' + money(TIER1 - total) + ' more</strong> for free shipping'
      : total < TIER2
        ? 'Add <strong>' + money(TIER2 - total) + ' more</strong> for a complimentary shirt'
        : '<strong>A complimentary shirt is on us</strong>';

    document.querySelectorAll('#iol-bar-fill').forEach(function (el) {
      el.style.width = Math.min(pct, 100) + '%';
    });
    document.querySelectorAll('#iol-progress-copy').forEach(function (el) {
      el.innerHTML = text;
    });
    milestone(1, total >= TIER1);
    milestone(2, total >= TIER2);
  }

  function milestone(n, reached) {
    ['iol-dot-', 'iol-label-', 'iol-reward-'].forEach(function (p) {
      document.querySelectorAll('#' + p + n).forEach(function (el) {
        el.classList[reached ? 'add' : 'remove']('reached');
      });
    });
  }

  /* Hide stepper + remove on the gift row.
     Blum indexes rows by position: #cartDrawerItem-N / #cartItem-N (1-based). */
  function lockGiftLine() {
    if (giftIndex < 0) return;
    var n = giftIndex + 1;

    var row = document.getElementById('cartDrawerItem-' + n);
    if (row) {
      row.classList.add('iol-gift-line');
      row.querySelectorAll('sht-cart-drwr-qty-inp, sht-cart-drwr-rmv-btn')
        .forEach(function (el) { el.style.display = 'none'; });
    }
    var pageRow = document.getElementById('cartItem-' + n);
    if (pageRow) {
      pageRow.classList.add('iol-gift-line');
      pageRow.querySelectorAll('sht-qty-inp, sht-cart-rmv-btn')
        .forEach(function (el) { el.style.display = 'none'; });
    }
  }

  function money(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  /* ─────────────────────────────────────────
     Triggers — fetch and XHR, since the theme
     may use either for cart writes.
  ───────────────────────────────────────── */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;

  var _fetch = window.fetch;
  window.fetch = function (url) {
    var out = _fetch.apply(this, arguments);
    if (!mutating && typeof url === 'string' && CART_WRITE.test(url)) out.then(sync, function () {});
    return out;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_WRITE.test(url)) {
      this.addEventListener('load', function () { if (!mutating) sync(); });
    }
    return _open.apply(this, arguments);
  };

  document.addEventListener('cart:update', function () { if (!mutating) sync(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

    /* ─────────────────────────────────────────
     Stock cap — block the + button at max and
     reuse the theme's own line-item error slot.
  ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '.js-cart-drawer-quantity-btn-plus, .js-quantity-btn-plus'
    );
    if (!btn) return;

    var wrap  = btn.closest('sht-cart-drwr-qty-inp, sht-qty-inp');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input || !input.hasAttribute('max')) return;

    var max = parseInt(input.getAttribute('max'), 10);
    if (isNaN(max) || parseInt(input.value, 10) < max) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var idx = input.getAttribute('data-index');
    var box = document.getElementById('cart-drawer-line-item-error-' + idx)
           || document.getElementById('line-item-error-' + idx);
    if (!box) return;

    var msg = box.querySelector(
      '.js-cart-drawer-form-item-error-message, .js-cart-form-item-error-message'
    );
    if (msg) {
      msg.textContent = max === 1
        ? 'Only 1 left in stock'
        : 'Only ' + max + ' left in stock';
    }
    box.classList.remove('d-none-important');
    clearTimeout(box._iolHide);
    box._iolHide = setTimeout(function () {
      box.classList.add('d-none-important');
    }, 4000);
  }, true);

  /* Lock page scroll while the drawer is open. */
  var drawerEl = document.getElementById('shtCartDrawer');
  if (drawerEl) {
    new MutationObserver(function () {
      var open = !drawerEl.hasAttribute('hidden') &&
                 drawerEl.getAttribute('aria-hidden') !== 'true';
      document.body.classList.toggle('iol-drawer-open', open);
    }).observe(drawerEl, { attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'class'] });
  }
  
})();